<template>
  <v-dialog v-model="dialogInvite" scrollable persistent max-width="500px" max-height="350px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">person_add</v-icon>&nbsp;&nbsp;{{$t('Dialog.group.headerInvite')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="Close">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>

        <v-card-text>
        <v-container fluid v-if="!progress">
          <v-layout align-center justify-center row wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field v-model="searchfriend" solo append-icon="search" :label="$t('Dialog.group.searching')" clearable style="">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center row wrap >
            <v-flex xs12 sm12 md12>
              <v-list two-line class="CSChatThai widthfull heightListSearch" style="padding: 0px; height: 160px;" v-if="FilterFriendList.length != 0" >
                    <template v-for="(item, index) in FilterFriendList">
                      <v-list-tile :key="item.tokenuser" avatar ripple >
                        <v-list-tile-action>
                          <v-checkbox v-model="selected" :value="item.tokenuser">
                          </v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-avatar>
                          <img  v-if="item.profilepicture"  :src="item.profilepicture" class="alligator-turtle">
                          <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="textoverflow">
                            {{ item.name }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-if="index + 1 < FriendList.length" :key="index"></v-divider>
                    </template>
                  </v-list>
                  <v-list v-else style="justify-content: center; display: flex;">
                    <v-progress-linear :indeterminate="progress"></v-progress-linear>
                   <!--  <h3>ไม่พบข้อมูล</h3> -->
                  </v-list>
            </v-flex>
          </v-layout>
          <!-- <v-layout row wrap>
            <v-flex sm12 md12 lg12 xl12 class="CSChatThai">
              <v-select
                label="เลือกเพื่อน"
                :items="FriendList"
                v-model="selected"
                item-text="name"
                item-value="tokenuser"
                multiple
                chips
                max-height="55vh"
                autocomplete
              >
                <template slot="selection" slot-scope="data">
                  <v-chip
                    close
                    @input="data.parent.selectItem(data.item)"
                    :selected="data.selected"
                    class="chip--select-multi CSChatThai"
                    :key="JSON.stringify(data.item)"
                  >
                    <v-avatar>
                      <img v-if="data.item.profilepicture" :src="data.item.profilepicture">
                      <img v-else-if="data.item.type === 'business'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png'>
                      <img v-else src='/static/img/default_profile/man-white.png'>
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data" style="max-height: 55vh; overflow-y: scroll;">
                  <template v-if="typeof data.item !== 'object'" >
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else >
                    <v-list-tile-avatar >
                      <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="alligator-turtle">
                      <img v-else-if="data.item.type === 'business'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png'>
                      <img v-else src='/static/img/default_profile/man-white.png'>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
          </v-layout> -->
        </v-container>
        <v-container v-else>
          <v-progress-linear :indeterminate="progress"></v-progress-linear>
        </v-container>
      </v-card-text>
       <v-card-actions >
        <!-- <v-spacer></v-spacer> -->
        <v-layout align-center justify-center row wrap>
          <v-flex xs6 sm6 md6>
            <v-layout align-center justify-end row wrap style="margin-right: 10px;">
              <v-btn class="btncancel"  v-on:click="Close()">{{$t('AnswerQuestion.cancel')}}</v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs6 sm6 md6>
            <v-layout align-center justify-start row wrap>
              <v-btn class="btnallow"  @click="invitefriends()" :disabled="selected.length == 0">{{$t('AnswerQuestion.ok')}}</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
// import { mapState } from 'vuex'
import { Decode } from '@/services'
export default {
  props: {dialogInvite: false, member: '', memberpending: '', group_id: ''},
  data: () => ({
    searchfriend: '',
    FriendList: [],
    token: '',
    selected: [],
    progress: false,
    business_id: '',
    businessidinvite: [],
    listmemberinvite: [],
    tokeninvite: [],
    typeuser: ''
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.business_id = localStorage.getItem('business_id')
    this.typeuser = localStorage.getItem('type_user')
  },
  computed: {
    FilterFriendList () {
      if (this.searchfriend !== '' && this.searchfriend !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.searchfriend.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    }
  },
  watch: {
    dialogInvite () {
      if (this.dialogInvite) {
        this.getlist()
      }
    }
  },
  methods: {
    Close () {
      this.$emit('closeInvite', false)
      this.selected = []
    },
    getlist () {
      this.selected = []
      var _ = require('lodash')
      this.axios.post(process.env.APIgo_api + '/v1/get-list-friend', {tokenuser: this.token}).then((response) => {
        this.FriendList = response.data['list_friend']
        this.FriendList = _.differenceBy(this.FriendList, this.member, 'tokenuser')
        this.FriendList = _.differenceBy(this.FriendList, this.memberpending, 'tokenuser')
      })
    },
    // searchuser (data) {
    //   var _ = require('lodash')
    //   var user = []
    //   var list = this.FriendList
    //   _.forEach(data, function (value) {
    //     user.push(_.find(list, function (o) { return o.tokenuser === value }))
    //   })
    //   return user
    // },
    invitefriends () {
      // for (var i = 0; i < this.selected.length; i++) {
      //   this.tokeninvite[i] = this.selected[i].tokenuser
      //   this.businessidinvite[i] = this.selected[i].business_id
      //   this.listmemberinvite[i] = {tokenuser: this.tokeninvite[i], business_id: this.businessidinvite[i]}
      //   if (i === this.selected.length - 1) {
      this.progress = true
      // console.log(this.selected)
      // process.env.APIgo_api + '/v1/invite-group'
      // process.env.APImanage + '/invitemembergroup'
      this.axios.post(process.env.APIgo_api + '/v1/invite-group', {group_id: this.group_id, tokenuser: this.token, listmember: this.selected}).then((response) => {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          this.progress = false
          this.$swal(
            '',
            this.$t('Alert.Success.inviteFriendGroup'),
            'success'
          )
          this.$emit('invitemembergroup')
          this.Close()
        } else {
          // console.log(response.data)
          this.progress = false
          this.$swal(
            '',
            this.$t('Alert.Fail.default.somethingWrong'),
            'error'
          )
          this.Close()
        }
      })
    }
  }
}
</script>
<style  lang="css" scoped>
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  /*box-shadow: none;*/
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/InviteGroupDialogMobile.vue